/**
 * Builds a display label like "Apparel > Baby > Rompers" from category IDs.
 */
export function buildCategoryBreadcrumb(
  categoryId,
  subCategoryId,
  subSubCategoryId,
  categories = [],
  nestedSubCategories = [],
) {
  if (!categoryId) return null;

  const category = categories.find((c) => String(c.id) === String(categoryId));
  if (!category?.name) return null;

  const parts = [category.name];

  if (subCategoryId) {
    const sub = (category.subcategories || []).find(
      (s) => String(s.id) === String(subCategoryId),
    );
    if (sub?.name) parts.push(sub.name);
  }

  if (subSubCategoryId) {
    const subSub = nestedSubCategories.find(
      (s) => String(s.id) === String(subSubCategoryId),
    );
    if (subSub?.name) parts.push(subSub.name);
  }

  return parts.join(" > ");
}
